// Adds chart-specific tooltip and data handling to series options.
export const formatSeries = (seriesArray) => seriesArray.map((series) => {
  if (series.id.match(/^wind_direction/)) {
    return {
      ...series,
      turboThreshold: 0,
      tooltip: {
        pointFormatter: function () {
          if (this.cardinal === 'CALM') {
            return `<span style="color:${this.color}">\u25CF </span>${series.name}: <b>CALM</b><br/>`
          }

          if (this.degrees == null) return null

          return `<span style="color:${this.color}">\u25CF </span>${series.name}: <b>${this.cardinal} (${this.degrees}\u00B0)</b><br/>`
        },
      },
    }
  }

  if (series.id.match(/^ann_.*sigma/) || series.useCategoryLabels) {
    return {
      ...series,
      tooltip: {
        pointFormatter: function () {
          return `<span style="color:${this.color}">\u25CF </span>${series.name}: <b>${this.series.yAxis.categories[this.y]}</b><br/>`
        },
      },
    }
  }

  return series
})

// Converts serialized numeric plot-band boundaries to numbers for Highcharts.
const normalizePlotBandBoundary = (value) => {
  if (typeof value !== 'string' || value.trim() === '') return value

  const numericValue = Number(value)
  return Number.isFinite(numericValue) ? numericValue : value
}

// Normalizes plot-band ranges and applies axis-specific label formatting.
export const formatYAxis = (yAxesArray) => yAxesArray.map((axis) => {
  const formattedAxis = axis.plotBands
    ? {
      ...axis,
      plotBands: axis.plotBands.map((plotBand) => ({
        ...plotBand,
        from: normalizePlotBandBoundary(plotBand.from),
        to: normalizePlotBandBoundary(plotBand.to),
      })),
    }
    : axis

  if (axis.id === 'y_axis_km_h') {
    return {
      ...formattedAxis,
      labels: {
        formatter: function () {
          if (parseInt(this.value, 10) >= 0) return this.value
          return null
        },
      },
    }
  }

  return formattedAxis
})

// Converts wind direction degrees to the orientation used by chart icons.
export const convertDegreesToIconAngle = (degrees) => {
  if (typeof degrees !== 'number') return null
  return degrees < 180 ? degrees + 180 : degrees - 180
}

// Creates Highcharts time options for the given site timezone.
export const buildTimezoneOptions = (timezoneName) => ({
  timezone: timezoneName,
})

// Builds range-selector buttons appropriate for the chart's visible time span.
export const buildRangeSelector = (
  xAxisRangeDiff,
  { allButtonsEnabled = false, minimumRangeForSelector = 174000000 } = {}
) => {
  if (xAxisRangeDiff < minimumRangeForSelector) {
    return null
  }

  if (xAxisRangeDiff < 610000000) {
    return {
      selected: 2,
      inputEnabled: false,
      allButtonsEnabled,
      buttons: [{
        type: 'millisecond',
        count: 86400000,
        text: '1d'
      }, {
        type: 'millisecond',
        count: 172800000,
        text: '2d'
      }, {
        type: 'millisecond',
        count: xAxisRangeDiff,
        text: 'All'
      }]
    }
  }

  if (xAxisRangeDiff < 2764800000) {
    return {
      selected: 4,
      inputEnabled: false,
      allButtonsEnabled,
      buttons: [{
        type: 'millisecond',
        count: 86400000,
        text: '1d'
      }, {
        type: 'millisecond',
        count: 172800000,
        text: '2d'
      }, {
        type: 'millisecond',
        count: 604800016,
        text: '1w'
      }, {
        type: 'millisecond',
        count: 1209600033,
        text: '2w'
      }, {
        type: 'millisecond',
        count: xAxisRangeDiff,
        text: 'All'
      }]
    }
  }

  return undefined
}
